import { MessageCircle } from "lucide-react";
import { WA_REVIEW } from "../constants/site";

export const Satisfaction = () => (
    <section
        id="satisfacao"
        data-testid="satisfaction-section"
        className="py-24 bg-[#f3f4f6] border-b border-neutral-200"
    >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
            <span className="text-xs font-bold uppercase tracking-widest text-[#ff6200]">
                Transparência Total
            </span>
            <h2 className="display-type text-3xl sm:text-4xl text-neutral-900 mt-2">
                SATISFAÇÃO DOS NOSSOS CLIENTES
            </h2>
            <div className="mt-4 p-6 bg-white rounded-xl border border-neutral-200 shadow-sm max-w-xl mx-auto">
                <p className="text-neutral-600 text-sm leading-relaxed">
                    Prezamos pelo feedback real de cada motorista atendido na região de Miracatu.
                    Compartilhe sua experiência com o serviço prestado — sua opinião chega diretamente
                    à nossa equipe.
                </p>
                <div className="mt-6">
                    <a
                        href={WA_REVIEW}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="satisfaction-whatsapp-btn"
                        className="bg-[#ff6200] hover:bg-[#e05600] text-white px-6 py-3 rounded font-bold text-xs uppercase tracking-wider inline-flex items-center gap-2 transition-colors"
                    >
                        <MessageCircle className="w-4 h-4" />
                        Avalie Nosso Atendimento via WhatsApp
                    </a>
                </div>
            </div>
        </div>
    </section>
);
